import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Description,
  GridContainer,
  GridSection,
  Title,
} from "../components/CommonComponents";
import GuideCard from "../components/GuideCard";
import GuideCarousel from "../components/GuideCarousel";
import GridArrow from "../components/GridArrow";
import backgound_image from "../images/background3.jpg";
import { width_detector_guide } from "../utills/utills";

const Align = styled.div`
  position: relative;
  padding: 50px 10%;
  top: 12%;
`;

function Guide() {
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    setIsOverflow(width_detector_guide());
    window.addEventListener("resize", () => setIsOverflow(width_detector_guide()));
    return window.addEventListener("resize", () =>
      setIsOverflow(width_detector_guide())
    );
  }, [isOverflow]);

  return (
    <GridContainer img={backgound_image} id="guide" className='page-container'>
      <GridArrow next_page="download"/>
      <GridSection>
        <Align>
          <Title>How to install each applications.</Title>
          <Description>
            See and follow the installation guide. Five minutes is enough
          </Description>
        </Align>
      </GridSection>
      <GridSection>{isOverflow ? <GuideCard /> : <GuideCarousel/>}</GridSection>
    </GridContainer>
  );
}

export default Guide;
